import React from "react";
import { Card, CardHeader, CardContent, Grid } from "@mui/material";
import { SdvFeatureStats, SdvFeatureDataGrid } from "../components/sdv-feature";

const SdvFeaturesFragment = () => {
  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <SdvFeatureStats />

        <Grid size={{ xs: 12 }}>
          <Card variant="outlined">
            <CardHeader title="Available SDV Features" />
            <CardContent sx={{ padding: 0 }}>
              <SdvFeatureDataGrid />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default SdvFeaturesFragment;
